import React from 'react';

export default React.lazy(() => import('./generate-bp-data'));

